import { Dialog, DialogActions, DialogContent } from "@mui/material";
import React from "react";
import Loader from "../loaders/Loader";

const AddressModal = ({
  open,
  setOpen,
  handleChange,
  isLoading,
  formError,
  addWalletAddress
}) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        scroll={"paper"}
        fullWidth={true}
        maxWidth={"sm"}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <DialogContent dividers={true}>
          <div className="input_field mt-2">
            <label className=" block font-semibold text-black text-14px md:text-18 mb-5">
              Enter the wallet address where you would like to receive your
              rewards.
            </label>
            <input
              type="text"
              placeholder="Enter Your Wallet Address (0x)...."
              name="walletAddress"
              onChange={handleChange}
              className="bg-[#fff] border border-[#69CEA6]"
            />
            {formError.formError && (
              <div className="form-eror">{formError.formError}</div>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <button
            onClick={addWalletAddress}
            type="button"
            className="btn btn-danger min-w-[130px] md:min-w-[200px] bg-[#69CEA6]"
          >
            {isLoading ? <Loader /> : "Submit"}
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddressModal;
